import { render } from "./CampaignCategoryManageListPage.vue?vue&type=template&id=fb807406&lang=true"
import script from "./CampaignCategoryManageListPage.vue?vue&type=script&lang=js"
export * from "./CampaignCategoryManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__